import {
	RouteLocationNormalizedGeneric,
	RouteLocationRaw,
	RouteLocationResolved,
	RouteParamsGeneric,
	useRouter as useVueRouter,
} from "vue-router";
import { useAppTabs } from "~stores/useAppTabs.ts";
import { defineAsyncComponent, h } from "vue";
import { AsyncComponentLoader } from "@vue/runtime-core";

function useRouter() {
	const router = useVueRouter();
	const { addTab, sessionTabs } = useAppTabs();
	const previousUrl = computed(() => {
		return router.options.history.state.back as string;
	});

	const previousRoute = computed(() => {
		return router.resolve({ path: previousUrl.value });
	});

	const routeToTab = (destination: RouteLocationRaw) => {
		const route: RouteLocationResolved = router.resolve(destination);
		const matchedRoute = route.matched[0];

		const comp = matchedRoute.components?.default;
		let component = comp;

		if (comp == undefined) {
			console.error(`No component found for route: ${destination}`);
			return;
		}

		if (comp instanceof Function) {
			component = defineAsyncComponent(comp as AsyncComponentLoader);
		}

		let props = matchedRoute.props.default;
		if (props instanceof Function) props = props(route as RouteLocationNormalizedGeneric);

		let title = route.meta?.tabTitle as string | ((params: RouteParamsGeneric) => string);
		if (title instanceof Function) title = title(route.params);

		addTab({
			title,
			fullPath: `${route.fullPath}?_t=${performance.now().toString()}`,
			props,
			component: h(component, props),
		});
	};

	return {
		...useVueRouter(),
		previousUrl,
		previousRoute,
		async push(route: RouteLocationRaw) {
			routeToTab(route);
		},
		async replace(route: RouteLocationRaw) {
			routeToTab(route);
		},
	};
}

export default useRouter;
